// Family/variant grouping for the "Retail Selection" supermarket-owner page.
// Detection is done via FR-prefix matching against product.nameFr.
// Order MATTERS — longer prefixes first to avoid mis-classification
// (e.g. "Gel Machine Auto" must be matched before "Gel Machine").

import {
  Droplets, UtensilsCrossed, Sparkles, Shirt, Flower2, Wind, ShowerHead,
  Flame, FlaskConical, SprayCan, Zap, Bug, Bath, Eraser, Droplet,
} from 'lucide-react';

export const FAMILIES = [
  {
    slug: 'savon-mains',
    prefix: 'Savon Mains',
    icon: Droplets,
    fr: 'Savon Mains',
    en: 'Hand Soap',
    ar: 'صابون اليدين',
    subCategory: 'personal-care',
    accentFrom: 'from-pink-500',
    accentTo: 'to-rose-600',
    bgTint: 'bg-pink-50',
    textAccent: 'text-pink-600',
  },
  {
    slug: 'lave-vaisselle',
    prefix: 'Lave Vaisselle',
    icon: UtensilsCrossed,
    fr: 'Lave Vaisselle',
    en: 'Dish Soap',
    ar: 'سائل الجلي',
    subCategory: 'kitchen',
    accentFrom: 'from-orange-500',
    accentTo: 'to-amber-600',
    bgTint: 'bg-orange-50',
    textAccent: 'text-orange-600',
  },
  {
    slug: 'gel-machine-auto',
    prefix: 'Gel Machine Auto',
    icon: Sparkles,
    fr: 'Gel Machine Auto (Vaisselle)',
    en: 'Auto Dishwasher Gel',
    ar: 'جل غسالة الصحون الأوتوماتيكية',
    subCategory: 'kitchen',
    accentFrom: 'from-cyan-500',
    accentTo: 'to-sky-600',
    bgTint: 'bg-cyan-50',
    textAccent: 'text-cyan-600',
  },
  {
    slug: 'gel-machine',
    prefix: 'Gel Machine',
    icon: Shirt,
    fr: 'Gel Machine (Linge)',
    en: 'Laundry Machine Gel',
    ar: 'جل غسالة الملابس',
    subCategory: 'laundry',
    accentFrom: 'from-sky-500',
    accentTo: 'to-blue-600',
    bgTint: 'bg-sky-50',
    textAccent: 'text-sky-600',
  },
  {
    slug: 'assouplissant',
    prefix: 'Assouplissant',
    icon: Flower2,
    fr: 'Assouplissant',
    en: 'Fabric Softener',
    ar: 'ملطف الأقمشة',
    subCategory: 'laundry',
    accentFrom: 'from-rose-500',
    accentTo: 'to-pink-600',
    bgTint: 'bg-rose-50',
    textAccent: 'text-rose-600',
  },
  {
    slug: 'desodorisant-ambiance',
    prefix: "Désodorisant d'Ambiance",
    icon: Wind,
    fr: "Désodorisant d'Ambiance",
    en: 'Air Freshener',
    ar: 'معطر جو',
    subCategory: 'home',
    accentFrom: 'from-violet-500',
    accentTo: 'to-purple-600',
    bgTint: 'bg-violet-50',
    textAccent: 'text-violet-600',
  },
  {
    slug: 'desodorisant',
    prefix: 'Désodorisant',
    icon: SprayCan,
    fr: 'Désodorisant',
    en: 'Deodorizer',
    ar: 'معطر',
    subCategory: 'home',
    accentFrom: 'from-indigo-500',
    accentTo: 'to-violet-600',
    bgTint: 'bg-indigo-50',
    textAccent: 'text-indigo-600',
  },
  {
    slug: 'gel-douche',
    prefix: 'Gel Douche',
    icon: ShowerHead,
    fr: 'Gel Douche',
    en: 'Shower Gel',
    ar: 'جل الاستحمام',
    subCategory: 'personal-care',
    accentFrom: 'from-fuchsia-500',
    accentTo: 'to-pink-600',
    bgTint: 'bg-fuchsia-50',
    textAccent: 'text-fuchsia-600',
  },
  {
    slug: 'apres-shampoing',
    prefix: 'Après-Shampoing',
    icon: Droplets,
    fr: 'Après-Shampoing',
    en: 'Conditioner',
    ar: 'بلسم',
    subCategory: 'personal-care',
    accentFrom: 'from-amber-500',
    accentTo: 'to-orange-600',
    bgTint: 'bg-amber-50',
    textAccent: 'text-amber-600',
  },
  {
    slug: 'shampoing',
    prefix: 'Shampoing',
    icon: Droplet,
    fr: 'Shampoing',
    en: 'Shampoo',
    ar: 'شامبو',
    subCategory: 'personal-care',
    accentFrom: 'from-yellow-500',
    accentTo: 'to-amber-600',
    bgTint: 'bg-yellow-50',
    textAccent: 'text-yellow-600',
  },
  {
    slug: 'anti-taches',
    prefix: 'Anti-Taches',
    icon: Eraser,
    fr: 'Anti-Taches',
    en: 'Stain Remover',
    ar: 'مزيل البقع',
    subCategory: 'laundry',
    accentFrom: 'from-red-500',
    accentTo: 'to-rose-600',
    bgTint: 'bg-red-50',
    textAccent: 'text-red-600',
  },
  {
    slug: 'anti-gras',
    prefix: 'Anti-Gras',
    icon: Flame,
    fr: 'Anti-Gras',
    en: 'Degreaser',
    ar: 'مزيل الدهون',
    subCategory: 'kitchen',
    accentFrom: 'from-orange-600',
    accentTo: 'to-red-600',
    bgTint: 'bg-orange-50',
    textAccent: 'text-orange-700',
  },
  {
    slug: 'eau-de-javel',
    prefix: 'Eau de Javel',
    icon: FlaskConical,
    fr: 'Eau de Javel',
    en: 'Bleach',
    ar: 'ماء جافيل',
    subCategory: 'home',
    accentFrom: 'from-sky-500',
    accentTo: 'to-cyan-600',
    bgTint: 'bg-sky-50',
    textAccent: 'text-sky-700',
  },
  {
    slug: 'gel-wc',
    prefix: 'Gel WC',
    icon: Bath,
    fr: 'Gel WC',
    en: 'WC Gel',
    ar: 'جل المرحاض',
    subCategory: 'home',
    accentFrom: 'from-teal-500',
    accentTo: 'to-emerald-600',
    bgTint: 'bg-teal-50',
    textAccent: 'text-teal-600',
  },
  {
    slug: 'nettoyant-vitres',
    prefix: 'Nettoyant Vitres',
    icon: Sparkles,
    fr: 'Nettoyant Vitres',
    en: 'Glass Cleaner',
    ar: 'منظف الزجاج',
    subCategory: 'home',
    accentFrom: 'from-cyan-500',
    accentTo: 'to-blue-600',
    bgTint: 'bg-cyan-50',
    textAccent: 'text-cyan-700',
  },
  {
    slug: 'parfum-de-linge',
    prefix: 'Parfum de Linge',
    icon: Flower2,
    fr: 'Parfum de Linge',
    en: 'Laundry Perfume',
    ar: 'عطر الغسيل',
    subCategory: 'laundry',
    accentFrom: 'from-pink-500',
    accentTo: 'to-rose-600',
    bgTint: 'bg-pink-50',
    textAccent: 'text-pink-700',
  },
  {
    slug: 'gel-power-oxygene',
    prefix: 'Gel Power Oxygène',
    icon: Zap,
    fr: 'Gel Power Oxygène',
    en: 'Power Oxygen Gel',
    ar: 'جل باور أكسجين',
    subCategory: 'laundry',
    accentFrom: 'from-blue-500',
    accentTo: 'to-indigo-600',
    bgTint: 'bg-blue-50',
    textAccent: 'text-blue-600',
  },
  {
    slug: 'olion-tox',
    prefix: 'Olion Tox',
    icon: Bug,
    fr: 'Olion Tox — Insecticide',
    en: 'Olion Tox Insecticide',
    ar: 'مبيد حشري أوليون توكس',
    subCategory: 'home',
    accentFrom: 'from-lime-600',
    accentTo: 'to-green-700',
    bgTint: 'bg-lime-50',
    textAccent: 'text-lime-700',
  },
];

// Find which family a product belongs to (by FR-name prefix).
export function findFamily(product) {
  return FAMILIES.find((f) =>
    product.nameFr === f.prefix || product.nameFr.startsWith(f.prefix + ' ')
  );
}

// Group a list of retail products into families → variants → sizes.
// Returns ordered array of:
//   { family, variants: [{ key, name{Fr,En,Ar}, image, products: [sized SKUs sorted] }] }
export function groupForSelection(products) {
  // Show retail + industrial sizes (resellers stock both 1L/3L/500ML AND 5L).
  // We filter only out products without uploaded photos to keep the page visual.
  const retail = products.filter(
    (p) => (p.category === 'retail' || p.category === 'industrial') && p.hasImage
  );

  const familyMap = new Map();

  for (const p of retail) {
    const family = findFamily(p);
    if (!family) continue;

    if (!familyMap.has(family.slug)) {
      familyMap.set(family.slug, { family, variantMap: new Map() });
    }
    const entry = familyMap.get(family.slug);

    // Variant key = full localized FR name (so different flavors group separately).
    const vKey = p.nameFr;
    if (!entry.variantMap.has(vKey)) {
      entry.variantMap.set(vKey, {
        key: vKey,
        nameFr: p.nameFr,
        nameEn: p.nameEn,
        nameAr: p.nameAr,
        image: p.image,
        products: [],
      });
    }
    entry.variantMap.get(vKey).products.push(p);
  }

  // Sort sizes inside each variant (numeric-ish).
  const sizeWeight = (s) => {
    if (!s) return 9999;
    const m = String(s).match(/([\d.]+)\s*(ML|L)/i);
    if (!m) return 9999;
    const n = parseFloat(m[1]);
    return m[2].toUpperCase() === 'L' ? n * 1000 : n;
  };

  // Convert maps → arrays, sorting variants by smallest-size availability and
  // preserving the global family order defined in FAMILIES.
  return FAMILIES
    .filter((f) => familyMap.has(f.slug))
    .map((f) => {
      const entry = familyMap.get(f.slug);
      const variants = Array.from(entry.variantMap.values()).map((v) => ({
        ...v,
        products: v.products.slice().sort((a, b) => sizeWeight(a.size) - sizeWeight(b.size)),
      }));
      // Sort variants alphabetically by FR name for predictable layout.
      variants.sort((a, b) => a.nameFr.localeCompare(b.nameFr, 'fr'));
      return { family: f, variants };
    });
}
